import Helpers from '../helpers';
import { STATUS_SERVICE_SUCCESS } from './constants';
import { getReturnResponseDefault } from './getReturnResponseDefault';
import { handleCodeErrorsResponse } from './codeErrorsResponse';
import { IFinalResponse, ICommonResponse, ErrorsDetailsTypes } from '../types';

const getApiError =
  (keys: string[]) =>
  (result: ErrorsDetailsTypes[], response: ICommonResponse, index: number) => {
    if (response.statusCode) {
      const isSuccess = Helpers.validations.isRangeNumber(
        Number(response.statusCode),
        STATUS_SERVICE_SUCCESS,
      );
      if (!isSuccess) {
        result.push({
          entity: response?.errorMetadata,
          errorCode: response?.errorCode,
          errorMessage: response?.errorMessage,
          errorMetadata: keys[index],
        });
      }
    }
    return result;
  };

/**
 * Factory to build generic IFinalResponse object
 * it is able to take lots of apiResponses and handles them all to
 */
export const coreServiceResponseFactory = ({
  apiResponses,
  definitions,
  contextKeys = [],
  finalResponseFn,
}: {
  apiResponses: ICommonResponse[];
  definitions: unknown[];
  contextKeys?: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  finalResponseFn: () => any;
}): IFinalResponse => {
  const errors = apiResponses.reduce(getApiError(contextKeys), []);
  const finalReturn = getReturnResponseDefault();
  const finalResponse = finalResponseFn();
  finalReturn.success = errors.length === 0;
  if (finalReturn.success) {
    finalReturn.data = finalResponse;
  } else {
    const infos = handleCodeErrorsResponse({
      errors,
      definitions,
    });

    finalReturn.errors = {
      flow: finalResponse,
      infos,
      details: errors,
    };
  }
  return finalReturn;
};
